import { createContext } from 'react';
import type { IStackProviderContext } from '../types';

export const StackProviderContext = createContext<IStackProviderContext>({
  stack: [],
});
